<template>
    <div>
        <PageTitle>Analisi reddituale</PageTitle>
        <AnnualIncomeStatementTable
          class="print-section"
          dense
          :isModuleSubsidizedFinanceEnabled="isModuleSubsidizedFinanceEnabled"
          :isModuleProjectsEnabled="isModuleProjectsEnabled"
          :yearsTableHeadings="yearsIncomeStatementTableHeadings"
          :yearsTableRows="yearsIncomeStatementTableRows"
        />
        <PageTitle>SP finanziario</PageTitle>
        <AnnualSPFTable
          class="print-section"
          dense
          :isModuleSubsidizedFinanceEnabled="isModuleSubsidizedFinanceEnabled"
          :yearsTableHeadings="yearsSPFTableHeadings"
          :yearsTableRows="yearsSPFTableRows"
        />
        <PageTitle>Cash Flow</PageTitle>
        <AnnualCashFlowTable
          class="print-section"
          dense
          :isModuleSubsidizedFinanceEnabled="isModuleSubsidizedFinanceEnabled"
          :yearsTableHeadings="yearsCashFlowTableHeadings"
          :yearsTableRows="yearsCashFlowTableRows"
        />
        <PageTitle>KPI</PageTitle>
        <KPITable
          class="print-section"
          dense
          :yearsTableHeadings="yearsKPITableHeadings"
          :yearsTableRows="yearsKPITableRows"
        />
    </div>
</template>

<script>

import { companyHasModule } from '@/helpers/modules.js';

export default {
  components: {
    AnnualCashFlowTable: () => import('@/views/components/Operative/OperativeTable/AnnualCashFlowTable.vue'),
    AnnualIncomeStatementTable: () => import('@/views/components/Operative/OperativeTable/AnnualIncomeStatementTable.vue'),
    AnnualSPFTable: () => import('@/views/components/Operative/OperativeTable/AnnualSPFTable.vue'),
    KPITable: () => import('@/views/components/Operative/OperativeTable/KPITable.vue'),
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle.vue'),
  },
  props: {
    company: {
      default: null,
      type: Object,
    },
    yearsCashFlowTableRows: {
      default: null,
      type: Object,
    },
    yearsCashFlowTableHeadings: {
      default: null,
      type: Array,
    },
    yearsSPFTableRows: {
      default: null,
      type: Object,
    },
    yearsSPFTableHeadings: {
      default: null,
      type: Array,
    },
    yearsIncomeStatementTableRows: {
      default: null,
      type: Object,
    },
    yearsIncomeStatementTableHeadings: {
      default: null,
      type: Array,
    },
    yearsKPITableRows: {
      default: null,
      type: Object,
    },
    yearsKPITableHeadings: {
      default: null,
      type: Array,
    },
  },
  computed: {
    isModuleSubsidizedFinanceEnabled () {
      return companyHasModule(this.company, 'SUBSIDIZED_FINANCE');
    },
    isModuleProjectsEnabled () {
      return companyHasModule(this.company, 'PROJECTS');
    },
  },
};

</script>

<style lang="scss">

#print-section-container {
  width: 100%;
  height: auto;

  .print-section {
    page-break-after: always;
  }
}

</style>
